import validator from 'validator';

const editInfo = (data) => {
  let errors = {}
  let regularExpression = /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{6,16}$/;

  const {name,email,phone_number,password} = data;

  if(validator.isEmpty(name)) {
    errors.name =  'Please enter a name'
  }
  
  if(validator.isEmpty(email)) {
    errors.email =  'Please enter an email'
  }
  
  if(validator.isEmpty(phone_number)) {
    errors.phone_number =  'Please enter a phone number'
  }
  
  if(validator.isEmpty(password)) {
    errors.password =  '새 비밀번호를 입력하세요.'
  }
  if (!password.match(regularExpression)) {
    errors.password = '영문/숫자/특수문자 포함 8자 이상 16자 미만';
  }
  return {
    isInvalid: Object.keys(errors).length > 0,
    error: errors
  }
}

export default editInfo;